"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
export const QUERY_CACHE_TIME = 5 * 60 * 1000;
function QueryProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [queryClient] = React.useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_CACHE_TIME,
        gcTime: QUERY_CACHE_TIME,
        refetchOnWindowFocus: false
      }
    }
  });
}
export default QueryProvider;